/**
 * Scroll strategy that doesn't do anything.
 */
var NoopScrollStrategy = (function () {
    function NoopScrollStrategy() {
    }
    NoopScrollStrategy.prototype.enable = function () { };
    NoopScrollStrategy.prototype.disable = function () { };
    NoopScrollStrategy.prototype.attach = function () { };
    return NoopScrollStrategy;
}());
export { NoopScrollStrategy };
//# sourceMappingURL=noop-scroll-strategy.js.map


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/md2/core/overlay/scroll/noop-scroll-strategy.js.pre-build-optimizer.js